import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {DashboardPage} from './pages';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardPage,
    // canActivate: [AuthGuardService],
    data: {title: 'Dashboard'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {


}




